import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import { CONTEXT_TRANSFERT_PRET, CONTEXT_RESTITUER_PRET } from '../../constants/apiUrls.constants';

const transferts = combineReducers({
    transfertPretStore: APIReducer.bind(null, CONTEXT_TRANSFERT_PRET),
    restituerPretStore: APIReducer.bind(null, CONTEXT_RESTITUER_PRET),
});

export default transferts;
